import { capitalize } from './capitalize';

/**
 * Normalizes backend enum strings (e.g., 'create', 'edit_grid') into human-readable Title Case strings.
 * Replaces underscores and hyphens with spaces before capitalizing each word.
 *
 * @param value - The string to format.
 * @returns The formatted Title Case string.
 *
 * @example
 * formatTitleCase('edit_grid') // 'Edit Grid'
 * formatTitleCase('create')    // 'Create'
 */
export function formatTitleCase(value?: string): string {
  if (!value) {
    return '';
  }
  return value.replace(/[_-]/g, ' ').replace(/\w\S*/g, (word: string): string => capitalize(word));
}
